module.exports = __webpack_public_path__ + "img/surat-add-penduduk-min.480b4b8f.png";